import React, { FC } from "react";

type Props = { 
    startingPage: number | 0; 
    numPages:number;
    selected: number;
    onPress(n:number):void;
}

export const PaginationButtons: FC<Props> = ({ numPages, onPress, selected, startingPage }) => {

    const maxVisible = 10;

    const min = Math.max(startingPage, selected - 5);

    const btns = [];
    for (let i = min; i < min + maxVisible; i++) { 
        if (i > numPages) break;
        const el = <button key={i} style={{ minWidth: '40px' }} className={`h-10 flex justify-center items-center text-center rounded-md py-2 px-3 border ${selected === i && 'border-blue-600'}`} onMouseDown={() => onPress(i)}><p className={` ${selected === i && ' text-blue-600 font-bold'}`}>{startingPage ==0? i + 1 : i}</p></button>
        btns.push(el);

    }

    return (
        <div className="px-20 my-5 w-full flex flex-1 flex-row gap-2 justify-center  items-start flex-wrap">
            {btns}
        </div>
    )
}